<template>
  <div>
    <v-btn :color="info.color" flat dark @click="openDialog()"
    v-if="this.data.btnSize === 'flat'">
      <v-icon left>
        {{info.icon}}
      </v-icon>
      {{info.title}}
    </v-btn>
    <v-btn icon @click="openDialog()"
    v-else>
      <v-icon :color="info.color" >
        {{info.icon}}
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="500">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor">
              {{info.icon}}
            </v-icon>
            <span :class="ui.textHeadline">
              {{info.title}}
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheadingBold">
              Policy Description
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{info.status}}
            </div>
            <v-spacer/>
            <div :class="ui.textSubheading">
              {{info.date}} | {{info.rev}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{info.policy}}
            </div>
          </v-layout>
          <div v-if="this.getDetailBasic.rdp !== this.getDataPrivacy.char.rev">
            <v-layout class="text-xs-left ml-3 mr-2 mt-2">
              <div :class="ui.textSubheadingWarning">
                New Data Privacy Released
              </div>
              <v-spacer/>
              <!-- <div :class="ui.textSubheadingWarning">
                Published
              </div> -->
            </v-layout>
            <v-layout class="text-xs-left ml-3 mr-2 mt-2">
              <div :class="ui.textSubheadingWarning">
                We have updated our Data Privacy Policy. Please review the policy and press Agree Button to confirm that you have understood new release and how it could potentially impact your business operations. Please contact us if you require any clarification on contact@besea.com.
              </div>
            </v-layout>
          </div>
          <v-layout row class="mt-4">
            <v-spacer/>
            <LegalCardPublic :data="{
              type: 'DP',
              btnColor: this.ui.btnColor,
              btnType: 'flat',
              enableAgreeBtn: false
              }"/>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-spacer/>
          <v-btn v-if="this.enableAgreeBtn"
          @click="updateStore()" :color="ui.btnColor" flat>
            <v-icon left> check_box_outline_blank </v-icon>
            Agree
          </v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import LegalCardPublic from "@/admin/general/components/LegalCardPublic";
import { mapGetters } from "vuex";
export default {
  // eslint-disable-next-line
  mixins: [
    adminFunctions,
    docRevsModFunctions,
    apptheme
  ],
  props: {
    data: {
      type: Object
    }
  },
  components: {
    LegalCardPublic
  },
  data() {
    return {
      dialog: false,
      valid: true,
      disableAddBtn: true,
      disableRemoveBtn: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      localForm: {
        item: ""
      },
      selection: ""
    };
  },
  computed: {
    ...mapGetters(["getDataPrivacy", "getDetailBasic"]),
    info() {
      let obj = {};
      obj.icon = "admin_panel_settings";
      obj.title = "Data Privacy Review";
      obj.policy = this.getDataPrivacy.char.policy;
      obj.status = this.getDataPrivacy.char.status;
      obj.rev = this.getDataPrivacy.char.rev;
      obj.date = this.getDataPrivacy.stats.date;
      obj.color = this.ui.btnColor;
      if (this.getDetailBasic.rdp !== this.getDataPrivacy.char.rev) {
        obj.color = this.ui.colorError;
      }
      return obj;
    },
    basic() {
      return this.getDetailBasic;
    },
    enableAgreeBtn() {
      if (this.basic.rdp === "" || this.info.rev !== this.basic.rdp) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.localForm.item = "";
      this.selection = "";
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    updateStore() {
      let basic = this.getDetailBasic;
      basic.rdp = this.getDataPrivacy.char.rev;
      // check act;
      // basic.act = this.checkUserOK(basic);
      // eslint-disable-next-line
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.$store.dispatch("changeDetailBasic", basic);
      this.dialog = false;
      this.saveDocumentRevMod(2.12); // user initial steup
    }
  }
};
</script>
